<template>
    <div class="customerLabel">
        <div class="content">
            <div class="scroll">
            <el-form ref="form" :model="query" label-width="80px">
                <el-form-item label="" v-if="types==4 ">
                    <el-radio-group @change="selectRes" v-model="form.resource">
                    <el-radio label="1">满足任意一个标签</el-radio>
                    <el-radio label="2">同时满足所有标签</el-radio>
                    <el-radio label="3">无标签客户</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="" v-if="types==5 " class="labLs">
                    <el-radio-group @change="selectRes" v-model="form.resource">
                    <el-radio label="1">全部</el-radio>
                    <el-radio label="2">运营标签</el-radio>
                    <el-radio label="3">规则标签</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="form.resource!=3  || types!=4">
                    <el-input placeholder="请输入关键词搜索标签"  v-model="query.keyword_search" @change="getList">
                        <i  slot="suffix" class="el-icon-search"></i>
                    </el-input>
                </el-form-item>
            </el-form>
            <ul class="list" v-if="form.resource!=3 || types!=4">
                <li v-for="(item,index) in listLabel" :key='index'>
                    <p class="title">{{item.group_name}}</p>
                    <div class="l" :style="{ 'max-height': item.status ? textHeight : '' }" :class="{ statusText: item.status }" ref="desc">
                        <span @click="checkLabel(t)" :class="isCheck(t.tag_id) ? 'clasCk' : ''"  v-for="(t,i) in item.tag" :key='i'>{{t.name}}</span>
                    </div>
                    <p class="zs" @click="item.status = !item.status" v-if="item.idShowText">
                        <span v-if="item.status">展开 <i class="el-icon-arrow-down"></i></span>
                        <span v-else>收回<i class="el-icon-arrow-up"></i></span>
                    </p>
                </li>
            </ul>
            <ul v-if="form.resource==3 && types==4">
                <li style="margin-top:60px;text-align:center;">选择无任何标签后，将筛选出没有被打上过任何标签的客户～</li>
            </ul>
            </div>
            <div class="cliear">
                <span v-if="form.resource==3 && types==4">将筛选无标签客户</span>
                <span v-else>已选中 <span style="color:#327EFF;padding:0;">4</span> 个标签</span>
                <el-button v-if="form.resource!=3 || types!=4" class="clear" type="text" @click="clera">清 空</el-button>
                <el-button v-if="types!=4 && types!=5" type="text" @click="addLabel">添加标签</el-button>
            </div>
        </div>
    </div>
</template>
<script>
const  QUERY={
  keyword_search:""
}
export default {
    props:{
        types:{
            type:Number,
            default:1
        }
    },
    data() {
        return {
            isRadio:"",
            query:JSON.parse(JSON.stringify(QUERY)),
            form:{
                resource:"1",
                tags:[1]
            },
            listLabel:[
                {
                    group_name:"来源标签",
                    status:true,
                    idShowText:true,
                    tag:[{name:"小程序模版消息",tag_id:1},{name:"公众号模版消息",tag_id:2},{name:"搜索打开",tag_id:3},{name:"扫描小程序码",tag_id:4},{name:"扫描小程序码",tag_id:4},{name:"公众号菜单",tag_id:4},{name:"公众号文章",tag_id:4},{name:"长按识别",tag_id:4},{name:"聊天卡片",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4}]
                },
                {
                    group_name:"分组名称",
                    status:true,
                    idShowText:true,
                    tag:[{name:"小程序模版消息",tag_id:1},{name:"公众号模版消息",tag_id:2},{name:"搜索打开",tag_id:3},{name:"扫描小程序码",tag_id:4},{name:"扫描小程序码",tag_id:4},{name:"公众号菜单",tag_id:4},{name:"公众号文章",tag_id:4},{name:"长按识别",tag_id:4},{name:"聊天卡片",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4}]
                },
                 {
                    group_name:"分组名称",
                    status:true,
                    idShowText:true,
                    tag:[{name:"小程序模版消息",tag_id:1},{name:"公众号模版消息",tag_id:2},{name:"搜索打开",tag_id:3},{name:"扫描小程序码",tag_id:4},{name:"扫描小程序码",tag_id:4},{name:"公众号菜单",tag_id:4},{name:"公众号文章",tag_id:4},{name:"长按识别",tag_id:4},{name:"聊天卡片",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4},{name:"标签一",tag_id:4}]
                }
            ],
            textHeight:null
        }
    },
    computed:{
        isCheck(){
            return function(tag_id){
                let is=false;
                this.form.tags.forEach(item=>{
                    console.log(item,tag_id)
                if(item==tag_id){
                    is=true;
                }
                })
                return is;
            }
        }
    },
    mounted(){
        console.log("开始咯")
        this.calculateText();
        // this.form.resource=1;
    },
    methods: {
        addLabel(){},
        selectRes(){

        },
        clera(){
            this.form.tags=[];
        },
        checkLabel(t){

        // let index=this.form.tags.findIndex(item=>item==t.tag_id);
        // if(index!=-1){
        //     this.form.tags.splice(index,1);
        // }else{
        //     this.form.tags.push({name:t.name,id:t.id});
        // }
        
        },
        selectRes(){
        },
        calculateText() {
            // 这是默认两行数据的高度，一行的高度可以自定义 可以*3 *4达到三行或者四行显示展示和收起的效果
            let twoHeight = 30 * 3;
            this.textHeight = `${twoHeight}px`;
            let l=this.$refs.desc;
            for(let i=0;i<l.length;i++){
                let index=l[i].dataset.index;
                let idx=l[i].dataset.i;
                let curHeight = l[i].offsetHeight;
                let d=this.listLabel[i];
                if (curHeight > twoHeight) {
                d.status = true;
                d.idShowText = true;
                } else {
                d.status = false;
                d.idShowText = false;
                }
            }
        },
        async getList(){
        // if(this.isRadio==1){
        //     var {result} = await CustomerTag(1,this.query);
        // }else if(this.isRadio==2){
        //     var {result} = await CustomerGroupTag(1,this.query);
        // }
        
        // if(result){
        //     result.forEach(item=>{
        //     item['status']=false;
        //     item['idShowText']=false;
        //     })
        //     this.form.tags=[];
        //     this.listLabel=result;
        //     setTimeout(() => {
        //     this.calculateText();
        //     }, 300);
        // }
        },
        set(){
            return this.form.tags
        }
    },
}
</script>
<style lang="less" scoped>
/deep/ .el-radio{
    margin-right:60px;
}
.labLs{
    /deep/ .el-radio{
        margin-right:130px;
        &:last-child{
            margin:0;
        }
    }
}
.clasCk{
    color: #fff !important;
    background: #258EF7 !important;
    border: 0px !important;
}
 .openSpan {
    position: absolute;
    right: 0;
    bottom: -4px;
  }
   .titleText {
    // font-weight: bold;
    font-size: 14px;
    line-height: 28px;
  }
  .openClose {
    font-size: 14px;
    color: #258EF7;
  }
  .openSpan {
    position: absolute;
    right: 0;
    bottom: -4px;
  }
  .statusText {
    overflow: hidden;
    display: block;
  }
  .statusText:after {
    content: "...";
    position: absolute;
    bottom: 0;
    right: 2px;
    width: 48px;
    padding-left: 30px;
    background: linear-gradient(to right, rgba(255,255,255,0.2), #fff 45%);
  }


.txt{
    padding:30px;
    span{
        color:#258EF7;
    }
}
.scroll{
    height:400px;
    overflow-y: auto;
     padding:30px;
}   
.content{
    position: relative;
   
    
}
/deep/ .el-form-item__content{
    margin-left:0 !important;
    text-align: center;
}
/deep/ .el-input .el-input__inner{
  border-radius: 30px;
  background: #F1F1F1;
}
.statusText::after{
    
        display: none;
    
    // display: bo;
}
.list{
    margin-bottom:30px;
    .title{
        padding-bottom:10px;
        color:#333;
        font-weight: 400;
    }
    .l{
        // text-align: center;
        span{
            margin-right: 15px;
            margin-bottom: 15px;
            display: inline-block;
            padding:5px 10px;
            background: #F6F6F9;
            border-radius: 15px;
            border: 1px solid #DBDFE6;
            color: #777777;
        }
    }
    .zs{
        margin-top:15px;
        text-align: center;
        color:#1890FF;
        i{
            display: inline-block;
            /* width: 16px; */
            /* height: 16px; */
            font-size: 13px;
            padding: 2px;
            /* text-align: center; */
            /* line-height: 16px; */
            background: #1890FF;
            color: #fff;
            border-radius: 50%;
        }
    }
}
.staff-model {
  position: relative;
}
.cliear{
   position: absolute;
    bottom: 0;
    left: 0;
    /* overflow: hidden; */
    width: 90%;
    background: #fff;
    padding-left: 30px;

    span{
        padding-right:15px;
    }
    .clear.el-button{
        color:#999;
    }
}
</style>